import React from 'react';

// Compact one-tap Light ↔ Dark toggle for the profile card corner.
// TEMPORARILY DISABLED (2026-02): the app is locked to light mode for A/B
// testing. Rendering `null` hides every existing usage across the app in one
// place, without touching each host / venue / staff / guest / admin page.
// To restore the toggle, replace this component with the previous
// implementation kept in git history (`git log -- src/components/ThemeToggle.js`).
export const ThemeToggle = () => {
  return null;
};

export default ThemeToggle;

